<template>
 <div id="logo">
    <mt-header title="登录"  fixed>
	  <router-link to="/" slot="left">
		  <mt-button icon="back" class="font-Yahei"></mt-button>
      </router-link>
	</mt-header>
	<div class="mt40"> 
		<p class="text-center pt45"><img src="../../../static/images/logo.png" alt="LOGO" width="90"/></p>
	</div>
	<section class="loginContent">
		<!--密码登录-->
		<div v-show="showaccount==true">
			<div class="login_line">
				<i class="logIco"><img src="../../../static/images/my_ico.png"/></i>
				<input type="tel" placeholder="手机号码" maxlength="11" v-model="phone" @input="vcodecheck"/>
			</div>
			<div class="login_line2">
				<i class="logIco"><img src="../../../static/images/password_login.png"/></i>
				<input :type="typepasswardo" placeholder="密码" v-model="passwordss" />
				<i @click="changetypeo" class="logIco2"><img :src="srcopeno"/></i>
			</div>
			<p><span class="fogglemi" @click="ToforgetPassword">忘记密码？</span></p>
			<!--:class="{disableColor:disableds==true}":disabled="disableds"-->
			<p><input type="button" value="登 录" class="btnLogin"  @click="btnLoginm" /></p>
			<!--<p class="loging_p"><router-link to="/Register" class="regText">注册账号</router-link><span class="regText" @click="Tomessage">短信验证登录</span></p>-->
			<p class="loging_p"><span @click="ToRegister" class="regText">注册账号</span><span class="regText" @click="Tomessage">短信验证登录</span></p>
		</div>
		<!--短信账号登录-->
		<div v-show="showaccount==false">
			<div class="login_line">
				<i class="logIco"><img src="../../../static/images/my_ico.png"/></i>
				<input type="tel" placeholder="手机号码" maxlength="11" v-model="phone" @input="vcodecheck"/>
			</div>
			<div class="login_line">
				<i class="logIco"><img src="../../../static/images/phone_ico.png"/></i>
				<input type="number" placeholder="手机验证码" v-model="vcode" maxlength="6" @input="vcodecheck"/>
				<button class="btnSend" @click="send" :disabled="disabled">
				   <span v-if="sendMsgDisabled">{{time+'秒后获取'}}</span>
	               <span v-if="!sendMsgDisabled">发送验证码</span>
				</button>
			</div>
			<p><input type="button" value="登 录" class="btnLogin" :class="{disableColor:disableds==true}" @click="btnLogin" :disabled="disableds"/></p>
			<p class="loging_p"><span @click="ToRegister" class="regText">注册账号</span><span class="regText" @click="Toaccount">账号密码登录</span></p>
		</div>
		<!--<div class="partyloginbox">
			<span class="border-top-line-login mr10"></span>
			<span class="partylogintext">第三方登录</span>
			<span class="border-top-line-login ml10"></span>
		</div>
		<div class="partyLogin">
			<span><a href="javascript:void(0)"><img src="../../../static/images/weixin.png"/></a></span>
			<span><img src="../../../static/images/QQ.png"/></span>
			<span class="mr0"><img src="../../../static/images/weibo.png"/></span>
		</div>-->
	</section>
 </div>
</template>

<script>
    import { Toast } from 'mint-ui'
	import { Indicator } from 'mint-ui'
	export default{
		data(){
			return{
			   time: 60, // 发送验证码倒计时
               sendMsgDisabled: false,
               disabled:false,
               phone:"",
               vcode:"",
               disableds:true,
               showaccount:true,
               typepasswardo:'password',
               srcopeno:'../../../static/images/closeeye.png',
               passwordss:"",
               md5sign:this.Act_md5sign,
//             movableType:this.$route.query.movableType,//渠道号 1.移动商城   2.电话钱包网   3.微信公众号
			}
		},
		created:function(){
			   
	    },
	    methods: {
	    	Tomessage(){
	    		this.showaccount=false;
	    	},
	    	Toaccount(){
	    		this.showaccount=true;
	    	},
	    	//点击忘记密码按钮
	    	ToforgetPassword(){
	    		this.$router.push({path: "/UserCenter/forgetPassword"});
	    	},
	    	ToRegister(){
	    		this.$router.push({path: "/Register",query:this.$route.query});
	    	},
	    	changetypeo(){
	           if(this.typepasswardo=='password'){
	           	 this.typepasswardo='text';
	           	 this.srcopeno='../../../static/images/openeye.png';
	           }else{
	           	 this.typepasswardo='password';
	           	 this.srcopeno='../../../static/images/closeeye.png';
	           }
	        },
	    	vcodecheck(){
	    		if(this.vcode.length>5&&this.phone.length==11){
	    			this.disableds=false;
	    		}else{
	    			this.disableds=true;
	    		}
	    	},
	     	userconfire(){
	     		var signM=md5('phone_num='+this.phone+'&'+this.md5sign);
	     		if(this.validatePhone()){
	     		  Indicator.open();
	     		  this.$http.post(this.URL_PREFIX+"/user/sendVerCode.net",{phone_num:this.phone,codeType:1,sign:signM})
				  .then((res) =>{
			  		Indicator.close();
			  		if(res.data.code!=200){
			  			Toast(res.data.msg);
			  		}else{
			  			Toast(res.data.msg);
			  			let me = this;
				        me.sendMsgDisabled = true;
				        me.disabled=true;
				        let interval = window.setInterval(function() {
				          if ((me.time--) <= 0) {
				            me.time = 60;
				            me.sendMsgDisabled = false;
				            me.disabled=false;
				            window.clearInterval(interval);
				          }                    
				        }, 1000);
					}
			  	});
		      }
	     	},
	     	//验证用户是否已经注册
	     	send(){
	     		if(this.validatePhone()){
		     		this.$http.post(this.URL_PREFIX+"/user/userIsExistence.net",{phone:this.phone})
					 .then((res) =>{
					 	if(res.data.code!=200){
					 	  Toast(res.data.msg);
					 	}else{
					 	   this.userconfire();
					 	}
					});
				}
	     	},
	     	//点击密码登录
	     	btnLoginm(){
	     	   if(this.validatePhone()){
	     		  if(this.validatepassword()){
	     		  	this.$http.post(this.URL_PREFIX+"/user/loginUser.net",{uName:this.phone,pwd:this.passwordss})
				  	.then((res) =>{
				  	    if(res.data.code==200){
				  	       Toast(res.data.msg);
				  	       localStorage.setItem('username',this.phone);
				  	       if(this.$route.query.redirect=="payState.html"){				  	       	
	              	 	  	 location.href="http://m.vcard8.com/payState.html";
	              	 	   }else if(this.$route.query.movableType==1||this.$route.query.movableType==3){
	              	 	   	    this.$router.push({path: "/Ticket/lucky?movableType="+this.$route.query.movableType});//渠道号 1.移动商城   2.电话钱包网   3.微信公众号
	              	 	   }else if(this.$route.query.movableType==2){
	              	 	   	    this.$router.push({path: "/Ticket/luckyPC?movableType="+this.$route.query.movableType});
	              	 	   }else{
	              	 	   	 this.$router.push(this.$route.query.redirect || '/');
	              	 	   }
				  	    }else{
				  	       Toast(res.data.msg);
				  	    }
				  	});
	     		  }
	     		}
	     	},
	     	//验证码登录
	     	btnLogin(){
	     	  if(this.validatePhone()){
	     		  if(this.vcode==""){
	     		  	  Toast("请输入手机验证码");
	     		  }else{
	     		  	this.$http.post(this.URL_PREFIX+"/user/loginUser.net",{uName:this.phone,verCode:this.vcode})
				  	.then((res) =>{
				  	    if(res.data.code==200){
				  	       Toast(res.data.msg);
				  	       localStorage.setItem('username',this.phone);
				  	       if(this.$route.query.redirect=="payState.html"){
	              	 	  	 location.href="http://m.vcard8.com/payState.html";
	              	 	   }else if(this.$route.query.movableType==1||this.$route.query.movableType==3){
	              	 	   	    this.$router.push({path: "/Ticket/lucky"});//渠道号 1.移动商城   2.电话钱包网   3.微信公众号
	              	 	   }else if(this.$route.query.movableType==2){
	              	 	   	    this.$router.push({path: "/Ticket/luckyPC"});
	              	 	   }else{
	              	 	   	 this.$router.push(this.$route.query.redirect || '/');
	              	 	   }
				  	    }else{
				  	       Toast(res.data.msg);
				  	    }
				  	});
	     		  }
	     		}
	     	},
	     	//手机号验证
	     	validatePhone(){
	     		var reg= /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
	     		if(this.phone==''){
                    Toast("请输入手机号码");
                   return false;
                }else if(!reg.test(this.phone)){
                    Toast("手机号格式不正确");
                    return false;
                }else{
                	return true;
                }
	     	},
	     	//登录密码验证
	     	validatepassword(){
	     		var reg= /^[a-zA-Z0-9\W_!@#$%^&*`~()-+=?]{6,20}$/
	     		var reg2 = /\s+/g;
	     		var reg3 = /[\u4E00-\u9FFF]/g;
	     		var reg4 = /[\u3002|\uff1f|\uff01|\uff0c|\u3001|\uff1b|\uff1a|\u201c|\u201d|\u2018|\u2019|\uff08|\uff09|\u300a|\u300b|\u3008|\u3009|\u3010|\u3011|\u300e|\u300f|\u300c|\u300d|\ufe43|\ufe44|\u3014|\u3015|\u2026|\u2014|\uff5e|\ufe4f|\uffe5]/;
	     		if(this.passwordss==''){
                    Toast("请输入密码");
                   return false;
                }else if(reg2.test(this.passwordss)){
                   Toast("密码不能包含空格");
                   return false;
                }else if(!reg.test(this.passwordss)){
                    Toast("密码必须为6-20位字母、数字或符号");
                    return false;
                }else if(reg3.test(this.passwordss)){
                    Toast("密码不能包含中文");
                    return false;
                }else if(reg4.test(this.passwordss)){
                    Toast("密码不能包含中文符号");
                    return false;
                }else{
                	return true;
                }
	     	},
	    }
	}
</script>

<style>
 @import "../../../static/css/user.css";
 #logo .login_line2{border: 1px solid #e0e0e0;padding: 10px;margin-bottom: 10px;overflow: hidden;border-radius: 5px;-webkit-border-radius: 5px;}
 #logo .login_line2 input{width: 68%;color: #333;font-size: 1.0rem;border: none;background: transparent;line-height: 30px;margin-left: 20px;float:left;height: 30px;}
 #logo .login_line2 .logIco{width: 26px;height: 26px;margin-top: 3px;float:left;}
.logIco2{width: 20px;height: 20px;margin-top: 3px;float:right;}
.logIco2 img{width: 100%;}
</style>     


// WEBPACK FOOTER //
// src/views/Login/index.vue